export class HeaderUserTemplate {
  _key!: string;
  name!: string;
  description!: string;
  state!: string;
}
